document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('[data-brand-video]');
  const button = document.querySelector('[data-video-toggle]');
  if (video && button) {
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const playLabel = button.textContent;
    const pauseLabel = button.dataset.pause || 'Ⅱ';
    let userPaused = false;
    let inView = false;
    const update = () => {
      button.textContent = video.paused ? playLabel : pauseLabel;
      button.setAttribute('aria-pressed', String(!video.paused));
    };
    const play = () => video.play().catch(update);
    button.addEventListener('click', () => {
      userPaused = !video.paused;
      if (video.paused) play(); else video.pause();
    });
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        if (inView && !userPaused && !motion.matches && !document.hidden) play();
        else if (!inView) video.pause();
      }, { threshold: .4 });
      observer.observe(video);
    }
    motion.addEventListener('change', () => { if (motion.matches) video.pause(); });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) video.pause();
      else if (inView && !userPaused && !motion.matches) play();
    });
    update();
  }
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => {
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
  });
});